export default {
	gaTrackingId: 'G-6DPTSXCH00',

	// apiRoot: 'http://130.208.108.86:8095/malid/',
	pageUrl: '/',
	apiRoot: (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? '//130.208.108.86:8095/malid/' : '/api_proxy/'
	// apiRoot: '/api_proxy/'
}



// WEBPACK FOOTER //
// ./src/config.js